/* =============================================================
   ILS custom pagination — TASK-1769
   Picker → popup → wheel → OK
   Safety: NO global click interception. Listeners only on:
     - each [data-ils-pagi-picker] (click → open)
     - the popup itself (delegated clicks inside it)
     - document keydown (Esc only, no preventDefault on other keys)
   ============================================================= */
(function () {
  'use strict';

  var ROW = 46;

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    }
  }

  function wireTriggers(root) {
    var triggers = (root || document).querySelectorAll('[data-ils-pagi-picker]:not([data-ils-pagi-wired])');
    triggers.forEach(function (btn) {
      btn.setAttribute('data-ils-pagi-wired', '1');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openPopup(btn);
      });
    });
  }

  // ----- popup state -----
  var pop = null;
  var listEl = null;
  var stepUp = null;
  var stepDown = null;
  var okBtn = null;
  var activeTrigger = null;
  var total = 0;
  var current = 1;
  var anchor = '';
  var scrollHandler = null;

  function getPopup() {
    if (pop) return pop;
    pop = document.querySelector('[data-ils-pagi-popup]');
    if (!pop) return null;
    listEl = pop.querySelector('[data-ils-pagi-list]');
    stepUp = pop.querySelector('[data-ils-pagi-step="-1"]');
    stepDown = pop.querySelector('[data-ils-pagi-step="1"]');
    okBtn = pop.querySelector('[data-ils-pagi-ok]');

    // guard against re-binding the delegated handler if pop got rediscovered
    if (pop.getAttribute('data-ils-pagi-wired') === '1') return pop;
    pop.setAttribute('data-ils-pagi-wired', '1');

    // delegated clicks INSIDE the popup only
    pop.addEventListener('click', function (e) {
      // TASK-1806 — safety net: any tap outside the white sheet closes the
      // popup. Covers transparent overlay and any margin clicks reliably on
      // mobile.
      if (!e.target.closest('.ils-pgpop__sheet')) {
        closePopup();
        return;
      }
      if (e.target.closest('[data-ils-pagi-close]')) {
        closePopup();
        return;
      }
      var stepEl = e.target.closest('[data-ils-pagi-step]');
      if (stepEl) {
        if (stepEl.disabled) return;
        var dir = parseInt(stepEl.getAttribute('data-ils-pagi-step'), 10) || 0;
        moveTo(centerIdx() + dir);
        return;
      }
      if (e.target.closest('[data-ils-pagi-ok]')) {
        commitSelection();
        return;
      }
      var row = e.target.closest('[data-ils-pagi-page]');
      if (row) {
        // tap on a number → centers it, does NOT select
        moveTo(parseInt(row.getAttribute('data-ils-pagi-page'), 10) - 1);
      }
    });

    return pop;
  }

  function buildWheel() {
    if (!listEl) return;
    var rows = '';
    for (var i = 1; i <= total; i++) {
      rows +=
        '<div class="ils-wheel__row" data-ils-pagi-page="' +
        i +
        '"><span class="pill">' +
        i +
        '</span></div>';
    }
    listEl.innerHTML =
      '<div class="ils-wheel__pad"></div>' + rows + '<div class="ils-wheel__pad"></div>';
  }

  function centerIdx() {
    if (!listEl) return 0;
    // Which row's centre is closest to the list's vertical centre right now.
    var mid = listEl.scrollTop + listEl.clientHeight / 2;
    var idx = Math.round((mid - 90 - ROW / 2) / ROW); // 90 = top pad height
    return Math.min(total - 1, Math.max(0, idx));
  }

  function highlight() {
    if (!listEl) return;
    var idx = centerIdx();
    var rws = listEl.querySelectorAll('.ils-wheel__row');
    rws.forEach(function (r, i) {
      r.classList.remove('is-center', 'is-near');
      if (i === idx) {
        r.classList.add('is-center');
      } else if (Math.abs(i - idx) === 1) {
        r.classList.add('is-near');
      }
    });
    if (stepUp) stepUp.disabled = idx <= 0;
    if (stepDown) stepDown.disabled = idx >= total - 1;
  }

  function moveTo(idx) {
    if (!listEl) return;
    idx = Math.min(total - 1, Math.max(0, idx));
    listEl.scrollTo({ top: idx * ROW, behavior: 'smooth' });
  }

  function openPopup(trigger) {
    var p = getPopup();
    if (!p || !listEl) return;
    activeTrigger = trigger;
    total = parseInt(trigger.getAttribute('data-total'), 10) || 1;
    current = parseInt(trigger.getAttribute('data-current'), 10) || 1;
    anchor = trigger.getAttribute('data-anchor') || '';
    if (total <= 1) return;

    buildWheel();
    p.hidden = false;
    document.documentElement.classList.add('ils-pagi-open');

    if (scrollHandler) listEl.removeEventListener('scroll', scrollHandler);
    scrollHandler = function () {
      highlight();
    };
    listEl.addEventListener('scroll', scrollHandler, { passive: true });

    // Center the current page by REAL DOM geometry: align the centre of the
    // current row with the centre of the visible list, regardless of pad/row
    // pixel drift. Falls back to ROW arithmetic only if the row isn't found.
    requestAnimationFrame(function () {
      var row = listEl.querySelector('[data-ils-pagi-page="' + current + '"]');
      if (row) {
        listEl.scrollTop = row.offsetTop + row.offsetHeight / 2 - listEl.clientHeight / 2;
      } else {
        listEl.scrollTop = (current - 1) * ROW;
      }
      highlight();
    });
  }

  function closePopup() {
    if (!pop) return;
    pop.hidden = true;
    document.documentElement.classList.remove('ils-pagi-open');
    if (listEl && scrollHandler) {
      listEl.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
    }
    activeTrigger = null;
  }

  function commitSelection() {
    var idx = centerIdx();
    var page = Math.min(total, Math.max(1, idx + 1));
    if (page === current) {
      closePopup();
      return;
    }
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('page', String(page));
      // anchor: preserve as the URL hash if provided (without duplicating leading '#')
      if (anchor) {
        u.hash = anchor.charAt(0) === '#' ? anchor : '#' + anchor;
      }
      window.location.href = u.toString();
    } catch (err) {
      // fallback: naive append
      var sep = window.location.search.indexOf('?') >= 0 ? '&' : '?';
      window.location.href =
        window.location.pathname + window.location.search + sep + 'page=' + page + (anchor || '');
    }
  }

  // Esc to close — keydown only, no other intercepts
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && pop && !pop.hidden) {
      closePopup();
    }
  });

  // Move popup out of any transformed ancestor (Dawn section reveal anims
  // add transform → that becomes the containing block for position:fixed,
  // which yanks the popup off-center). Keep exactly one, append to <body>.
  function relocatePopup() {
    if (!document.body) return;
    var nodes = document.querySelectorAll('[data-ils-pagi-popup]');
    if (!nodes.length) return;
    var keep = nodes[0];
    for (var i = 1; i < nodes.length; i++) {
      if (nodes[i].parentNode) nodes[i].parentNode.removeChild(nodes[i]);
    }
    if (keep.parentNode !== document.body) {
      document.body.appendChild(keep);
    }
    keep.setAttribute('data-ils-pagi-popup-relocated', '1');
    // reset cached refs so getPopup() re-queries the (now relocated) node
    pop = null;
    listEl = null;
    stepUp = null;
    stepDown = null;
    okBtn = null;
  }

  ready(function () {
    relocatePopup();
    wireTriggers();
    // Re-wire on dynamic insertions (e.g. AJAX-rendered facets) — observe document body
    var mo = new MutationObserver(function (muts) {
      var needsRelocate = false;
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.addedNodes && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType === 1) {
              if (n.matches && n.matches('[data-ils-pagi-picker]')) {
                wireTriggers(n.parentNode || document);
              } else if (n.querySelector && n.querySelector('[data-ils-pagi-picker]')) {
                wireTriggers(n);
              }
              // catch a freshly-rendered popup (AJAX section re-render) and re-relocate
              if (
                (n.matches && n.matches('[data-ils-pagi-popup]') && n.parentNode !== document.body) ||
                (n.querySelector && n.querySelector('[data-ils-pagi-popup]'))
              ) {
                needsRelocate = true;
              }
            }
          }
        }
      }
      if (needsRelocate) relocatePopup();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
